export const getFlashMessages = ({ flashMessages }) => flashMessages;
